import type { GameRules, ShopItem } from "../../services/generated/client.js";

/**
 * What one item costs under these rules.
 *
 * A switch rather than an index, because `GameRules` also carries `cards_to_win`
 * — indexing it by `ShopItem` would compile today and start returning a
 * completely unrelated number the day somebody adds a field.
 */
export function priceOf(rules: GameRules, item: ShopItem): number {
  switch (item) {
    case "challenge":
      return rules.challenge;
    case "steal":
      return rules.steal;
    case "skip":
      return rules.skip;
    case "narrow_options":
      return rules.narrow_options;
    case "blind_timeline":
      return rules.blind_timeline;
    case "insurance":
      return rules.insurance;
  }
}
